exports.register = (module) ->
    module.factory 'Core.Services.Steps', [
        '$state'
        # add dependencies to inject here
        (args...) ->
            return {
                new: () ->
                    return new exports.Steps(args...)
            }
    ]

class exports.Steps
    constructor: (state) ->
        @steps = []
        @state = state
        @activeStep = null
        @eventPrefix = null
        @callbacks = []


    once: (eventname, stepname, cb) =>
        @callbacks.push
            name: "#{eventname}:#{stepname}"
            callback: cb
            once: true

    on: (eventname, stepname, cb) =>
        @callbacks.push
            name: "#{eventname}:#{stepname}"
            callback: cb
            once: false


    fire: (event, data) =>
        matches = _.filter @callbacks, { name: event }

        for m in matches
            if m.once
                _.remove(@callbacks, m)
            m.callback(data, event)

    destroy: () =>
        if @activeStep?
            @fire("switch-from:#{@_stepTitle(@activeStep)}", { is_forward: true })


    # Sets the angular scope so we can do broadcasts
    # and change fullpage settings. This is optional.
    setScope: (scope) ->
        @scope = scope

    setEventPrefix: (prefix) ->
        @eventPrefix = prefix

    setSteps: (steplist) ->
        @steps = steplist

    setExitCallback: (cb) =>
        @exitProcess = cb

    # Disable a step by name
    disableStep: (name) =>
        id = @_findStepIndex(name)
        @steps[id].disabled = true

    # Enable a step by name
    enableStep: (name) =>
        id = @_findStepIndex(name)
        @steps[id].disabled = false

    # Goes to the next (non-disabled) step
    gotoNextStep: () =>
        next = @_findStep(@activeStep.name ? @activeStep.state)

        if @scope and @eventPrefix
            @scope.$broadcast("#{@eventPrefix}:steps-next") # Event so steps know which way we're going
        @gotoStep(@steps[next], true)


    # Goes to the previous (non-disabled) step
    gotoPrevStep: () =>
        prev = @_findStep(@activeStep.name ? @activeStep.state, false)

        if prev < 0
            @exitProcess()
        else
            if @scope and @eventPrefix
                @scope.$broadcast("#{@eventPrefix}:steps-prev") # Event so steps know which way we're going
            @gotoStep(@steps[prev], false)

    # Finds the next (or previous) step using a step name
    _findStep: (name, next = true) =>
        currid = @_findStepIndex(name)

        if next
            steps = @steps
        else
            steps = @steps.slice().reverse()
            currid = steps.length - currid - 1

        for step, ind in steps when ind > currid
            if not step.disabled
                if not next
                    return (steps.length - ind - 1)
                return ind

        return -1

    # Given a step's name, returns the index in steps array
    _findStepIndex: (name) =>
        for step, ind in @steps
            if step.name is name or (not step.name and step.state is name)
                return ind
                break

    _stepTitle: (step) =>
        return step.name ? step.state

    getStepAt: (index) =>
        return @steps[index]

    # Activate a given step. Takes the step object as it's parameter
    gotoStep: (step, is_forward) =>
        if step and not step?.state?
            step = @steps[@_findStepIndex(step)]

        return if not step?

        if @activeStep?
            @activeStep.active = false
            @fire("switch-from:#{@_stepTitle(@activeStep)}", { is_forward: is_forward })

        @activeStep = step
        step.active = true
        step.visited = true

        if @state.$current.toString() isnt step.state
            @state.go step.state

        if step.fullpage and @scope
            @scope.show_fullpage = true
        else
            @scope.show_fullpage = false

        @fire("switch-to:#{@_stepTitle(@activeStep)}", { is_forward: is_forward })
